<ng-container *ngIf="data.video; else empty">
  <i
    class="fal fa-video fa-2x vehicle-images-icon"
    (click)="showVideo(dialog)"
    [title]="data.title"
  ></i>
</ng-container>
<ng-template #empty>-</ng-template>
<ng-template #dialog let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div *ngIf="playVideo">
        <video id="video" [src]="data.video" appSecureVideo controls autoplay></video>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
